type Priority = 'Very High' | 'High' | 'Medium' | 'Low'

const config: Record<Priority, { bg: string; text: string; dot: string }> = {
  'Very High': { bg: 'bg-red-50',    text: 'text-red-600',    dot: 'bg-red-500' },
  'High':      { bg: 'bg-orange-50', text: 'text-orange-600', dot: 'bg-orange-500' },
  'Medium':    { bg: 'bg-yellow-50', text: 'text-yellow-700', dot: 'bg-yellow-500' },
  'Low':       { bg: 'bg-gray-100',  text: 'text-gray-500',   dot: 'bg-gray-400' },
}

export default function PriorityBadge({ priority }: { priority: Priority }) {
  const c = config[priority]
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-bold whitespace-nowrap ${c.bg} ${c.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${c.dot}`} />
      {priority}
    </span>
  )
}
